/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, Collapse, IconButton, Tooltip } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
  });

const styles = theme => ({

})

class ClassCard extends Component {
    state = {
        open_card : false
    }

    getProbability = (number) => {
        let string_number = Math.floor(number * 100)
    }

    renderClasses = () => {
        // Default display of the results is in descending order
        let classes = this.props.label.result.sort((a, b) => (b.probability - a.probability)).map(class_item => {
            return (
                <Fragment>
                    <div style = {{width : '100%', padding : '5px'}}>
                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>                          
                            <Typography style = {{flexGrow : 1}} variant = 'body2'>{class_item.class[this.props.label["label-column"][0]]}</Typography>                                
                            <Typography variant = 'overline'><em>{ (parseFloat(class_item.probability) * 100).toFixed(2).toString() + "%"}</em></Typography>
                        </div>
                        <div style = {{width : '100%', height : '5px', backgroundColor: 'rgba(0,0,0,0.12)'}}>
                            <div style = {{width : parseFloat(class_item.probability * 100).toFixed(2).toString() + "%", height : '5px', backgroundColor : '#00B1FE'}}></div>
                        </div>
                    </div>
                    <Divider style = {{marginTop : '3px', marginBottom : '3px'}}/>
                </Fragment>
            )
        })
        return classes
    }

    renderTopClass = () => {
        let top_class = this.props.label.result.sort((a, b) => (b.probability - a.probability)).map((class_item, i) => {
            if (i === 0) {
                return (
                    <Typography style = {{flexGrow : 1}} variant = 'button' color = 'primary'>{class_item.class[this.props.label["label-column"][0]]}</Typography>
                )
            }
        })

        return top_class
    }

    renderLowerClasses = () => {
        
    }

    render() {
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', padding : '5px'}}>
                    <Paper variant = 'outlined' style = {{boxSizing : 'border-box', width : '100%', padding : '10px'}}>
                        <Typography variant = 'overline'>{this.props.label["label-column"][0]}</Typography>
                        <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            {this.props.label.result.length>0?
                                <div style = {{flexGrow : 1}}>
                                    {this.renderTopClass()}
                                </div>:<Typography style = {{display : 'block', fontStyle : 'italic'}} variant = 'caption'>No results</Typography>
                            }
                            <Tooltip title = {this.state.open_card ? "Hide Probabilities" : "Show Probabilities"}>
                                <IconButton size = 'small' color = 'primary' onClick = {() => this.setState({...this.state, open_card : !this.state.open_card})}>
                                    {this.state.open_card ? <ExpandLess fontSize = 'small'/> : <ExpandMore fontSize = 'small'/>}
                                </IconButton>
                            </Tooltip>
                        </div>
                            <Collapse in = {this.state.open_card}>
                                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                                {this.renderClasses()}
                            </Collapse>
                        <Divider style = {{marginTop : '5px', marginBottom : '5px'}} />
                        <Typography style = {{display : 'block'}} variant = 'caption'>Information Channel</Typography>
                        <Typography style = {{display : 'block'}} variant = 'subtitle2'>{this.props.label.ic_name}</Typography>
                    </Paper>
                </div>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(ClassCard);